module.exports = __webpack_public_path__ + "static/media/arduino_id_logo.54722682.png";